import React, { useEffect, useRef } from 'react';
import classnames from 'classnames';
import { useNavigate } from 'react-router-dom';
import { DicomMetadataStore, MODULE_TYPES, useSystem } from '@ohif/core';

import Dropzone from 'react-dropzone';
import filesToStudies from './filesToStudies';

import { extensionManager } from '../../App';

import { Button, Icons } from '@ohif/ui-next';

const getLoadButton = (onDrop, text, isDir) => {
  return (
    <Dropzone
      onDrop={onDrop}
      noDrag
    >
      {({ getRootProps, getInputProps }) => (
        <div {...getRootProps()}>
          <Button
            variant="default"
            className="w-28"
            disabled={false}
            onClick={() => {}}
          >
            {text}
            {isDir ? (
              <input
                {...getInputProps()}
                webkitdirectory="true"
                mozdirectory="true"
                style={{ display: 'none' }}
              />
            ) : (
              <input
                {...getInputProps()}
                style={{ display: 'none' }}
              />
            )}
          </Button>
        </div>
      )}
    </Dropzone>
  );
};

type LocalProps = {
  modePath: string;
};

function Local({ modePath }: LocalProps) {
  const { servicesManager } = useSystem();
  const { customizationService } = servicesManager.services;
  const navigate = useNavigate();
  const dropzoneRef = useRef();
  const [dropInitiated, setDropInitiated] = React.useState(true);

  const LoadingIndicatorProgress = customizationService.getCustomization(
    'ui.loadingIndicatorProgress'
  );

  // Initializing the dicom local dataSource
  const dataSourceModules = extensionManager.modules[MODULE_TYPES.DATA_SOURCE];
  const localDataSources = dataSourceModules.reduce((acc, curr) => {
    const mods = [];
    curr.module.forEach(mod => {
      if (mod.type === 'localApi') {
        mods.push(mod);
      }
    });
    return acc.concat(mods);
  }, []);

  const firstLocalDataSource = localDataSources[0];
  const dataSource = firstLocalDataSource.createDataSource({});

  const microscopyExtensionLoaded = extensionManager.registeredExtensionIds.includes(
    '@ohif/extension-dicom-microscopy'
  );

  useEffect(() => {
    console.log("one")

    const query = new URLSearchParams(document.location.search);
    let host = query.get('host');
    let file = query.get('f');

    let DownloadedFiles = [];
    window.addEventListener('message', async function (event) {
      const expected_source = 'medical_platform';
      const data = event.data;
      const origin = event.origin;
      const source = data.source || null;
      console.log('origin', origin);
      console.log('source', source);
      console.log('data', data);

      if (source !== expected_source) {
        return;
      }

      // data.files may be an array of ArrayBuffers (transferables) or base64 strings
      const filesArray = data.files || [];

      for (let i = 0; i < filesArray.length; i++) {
        const fileItem = filesArray[i];

        try {
          if (fileItem instanceof ArrayBuffer) {
            const blob = new Blob([fileItem]);
            const f = new File([blob], 'f' + i, { lastModified: new Date().getTime() });
            DownloadedFiles.push(f);
          } else if (fileItem && fileItem.buffer && fileItem.buffer instanceof ArrayBuffer) {
            // Uint8Array
            const blob = new Blob([fileItem]);
            const f = new File([blob], 'f' + i, { lastModified: new Date().getTime() });
            DownloadedFiles.push(f);
          } else if (typeof fileItem === 'string') {
            // assume base64 string
            const b64 = fileItem.indexOf(',') !== -1 ? fileItem.split(',')[1] : fileItem;
            // atob -> Uint8Array
            const binary = atob(b64);
            const len = binary.length;
            const bytes = new Uint8Array(len);
            for (let j = 0; j < len; j++) {
              bytes[j] = binary.charCodeAt(j);
            }
            const blob = new Blob([bytes]);
            const f = new File([blob], 'f' + i, { lastModified: new Date().getTime() });
            DownloadedFiles.push(f);
          } else {
            console.warn('[DICOM] Unsupported fileItem type, skipping', fileItem);
          }
        } catch (e) {
          console.error('[DICOM] Error processing incoming file item', e);
        }
      }

      console.log("[DICOM] files to study", DownloadedFiles);
      const studies = await filesToStudies(DownloadedFiles, dataSource);
      studies.forEach(id => query.append('StudyInstanceUIDs', id));
      console.log("[DICOM] studies", studies);

      if (!studies) {
        return;
      }

      console.log("[DICOM] studies apply");

      navigate(`/${modePath}?${decodeURIComponent(query.toString())}`);
    });
    console.log(window.parent)
    const data = {
      source: "ohif_viewer",
      file: file,
    };
    window.parent.postMessage(data, '*');
  }, []);

  // const updateStudies = (studies: any[]) => {
  //   studyMetadataManager.purge();
  //
  //   // Map studies to new format, update metadata manager?
  //   const updatedStudies = studies.map(study => {
  //     const studyMetadata = new OHIFStudyMetadata(
  //       study,
  //       study.StudyInstanceUID
  //     );
  //     const sopClassHandlerModules =
  //       extensionManager.modules['sopClassHandlerModule'];
  //
  //     study.displaySets =
  //       study.displaySets ||
  //       studyMetadata.createDisplaySets(sopClassHandlerModules);
  //
  //     studyMetadata.forEachDisplaySet(displayset => {
  //       displayset.localFile = true;
  //     });
  //
  //     studyMetadataManager.add(studyMetadata);
  //
  //     return study;
  //   });
  //
  //   this.setState({
  //     studies: updatedStudies,
  //   });
  // };

  const onDrop = async acceptedFiles => {
    const studies = await filesToStudies(acceptedFiles, dataSource);

    const query = new URLSearchParams();

    if (microscopyExtensionLoaded) {
      // TODO: for microscopy, we are forcing microscopy mode, which is not ideal.
      //     we should make the local drag and drop navigate to the worklist and
      //     there user can select microscopy mode
      const smStudies = studies.filter(id => {
        const study = DicomMetadataStore.getStudy(id);
        return (
          study.series.findIndex(s => s.Modality === 'SM' || s.instances[0].Modality === 'SM') >= 0
        );
      });

      if (smStudies.length > 0) {
        smStudies.forEach(id => query.append('StudyInstanceUIDs', id));

        modePath = 'microscopy';
      }
    }

    // Todo: navigate to work list and let user select a mode
    studies.forEach(id => query.append('StudyInstanceUIDs', id));
    query.append('datasources', 'dicomlocal');

    navigate(`/${modePath}?${decodeURIComponent(query.toString())}`);
  };

  // Set body style
  useEffect(() => {
    document.body.classList.add('bg-black');
    return () => {
      document.body.classList.remove('bg-black');
    };
  }, []);

  return (
    <Dropzone
      ref={dropzoneRef}
      onDrop={acceptedFiles => {
        setDropInitiated(true);
        onDrop(acceptedFiles);
      }}
      noClick
    >
      {({ getRootProps }) => (
        <div
          {...getRootProps()}
          style={{ width: '100%', height: '100%' }}
        >
          <div className="flex h-screen w-screen items-center justify-center">
            <div className="bg-muted border-primary/60 mx-auto space-y-2 rounded-xl border border-dashed py-12 px-12 drop-shadow-md">
              <div className="flex items-center justify-center">
                <Icons.OHIFLogoColorDarkBackground className="h-18" />
              </div>
              <div className="space-y-2 py-6 text-center">
                {dropInitiated ? (
                  <div className="flex flex-col items-center justify-center pt-12">
                    <LoadingIndicatorProgress className={'h-full w-full bg-black'} />
                  </div>
                ) : (
                  <div className="space-y-2">
                    <p className="text-primary pt-0 text-xl">
                      Drag and drop your DICOM files & folders here <br />
                      to load them locally.
                    </p>
                    <p className="text-muted-foreground text-base">
                      Note: Your data remains locally within your browser
                      <br /> and is never uploaded to any server.
                    </p>
                  </div>
                )}
              </div>
              <div className="flex justify-center gap-2 pt-4">
                {getLoadButton(onDrop, 'Load files', false)}
                {getLoadButton(onDrop, 'Load folders', true)}
              </div>
            </div>
          </div>
        </div>
      )}
    </Dropzone>
  );
}

export default Local;
